import React from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PAGEPATHS, SIDEBARDATA } from 'components/Common/Constant';

const PagesForbidden = () => {
    document.title = "Error 403 | Lexa - Responsive Bootstrap 5 Admin Dashboard";
    const navigate = useNavigate();
    const user = useSelector((state) => state?.users?.users);

    const getRedirectPath = () => {
        return SIDEBARDATA.find(
            obj => obj.route === PAGEPATHS.Scanlist && user?.permissions?.read.includes(obj.pageCode)
        )?.route || PAGEPATHS.Login;
    };

    return (
        <React.Fragment>
            <div
                className="d-flex align-items-center justify-content-center vh-100"
                style={{ background: 'linear-gradient(135deg,rgb(194, 83, 4),rgb(194, 5, 96))' }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8" lg="6" xl="5">
                            <Card className="shadow-lg border-0">
                                <CardBody className="text-center p-5">
                                    <div className="mb-3">
                                    </div>
                                    <h1 className="display-1 fw-bold text-black">403</h1>
                                    <h3
                                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                        className="text-black d-flex justify-content-center align-items-center"
                                    >
                                        <i style={{ fontSize: '1em' }} className="mdi mdi-lock-off-outline me-1"></i>
                                        Forbidden!
                                    </h3>
                                    <p className="text-black-50 mb-4">
                                        The page you're trying to access has restricted access.
                                        <span className='text-black'> Please contact your administrator.</span>
                                    </p>
                                    <div>
                                        <Button
                                            className="me-2 text-white ms-2"
                                            color="light"
                                            outline
                                            onClick={() => navigate(getRedirectPath())}
                                            style={{ backgroundColor: '#ff6a00' }}
                                        >
                                            Go Back
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-4 text-center text-white-50">
                                <small>
                                    ©2021 Lexa - Crafted with <i className="mdi mdi-heart text-danger"></i> by ITF Solutions
                                </small>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PagesForbidden;